import { Box, Text, Icon, Grid } from "@storyofams/react-ui";
import Image from "next/image";
import { ArrowRightStep } from "~components/common/Icons";
import useMediaQuery from "~hooks/useMediaQuery";

export const Steps = ({ content }) => {
  const length = content?.steps?.length;
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  const isFiveSteps = matchesMobile && length === 5;
  return (
    <Box width={"100%"}>
      <Text
        textAlign={"center"}
        fontFamily={"DINPro"}
        fontWeight={700}
        fontSize={["36px", 5]}
        letterSpacing={"0.4px"}
        mb={"24px"}
      >
        {content.title}
      </Text>
      <Grid
        rowSize={[2, length === 6 ? 3 : length]}
        columnGap={[3, 1.5]}
        rowGap={[3, 0]}
      >
        {content.steps
          .slice(0, isFiveSteps ? 4 : length)
          .map((step, i, arr) => (
            <Box position={"relative"} key={i}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                position={"relative"}
                p={[0, "20px"]}
              >
                <Text
                  mb={"12px"}
                  color={
                    step?.step_color?.color ? step.step_color.color : "#8B7B8D"
                  }
                  fontWeight={500}
                  letterSpacing={"0.1em"}
                  fontSize={"12px"}
                >
                  STEP {i + 1}
                </Text>
                <Box position={"relative"}>
                  <Image
                    width={80}
                    height={80}
                    objectFit="cover"
                    src={step.icon.filename}
                  />
                </Box>
                <Text
                  mt={"12px"}
                  fontSize={2}
                  px={"20px"}
                  color={"#000000CC"}
                  lineHeight={"22.4px"}
                  textAlign={"center"}
                >
                  {step.description}
                </Text>
              </Box>
              <Box
                display={[
                  i % 2 ? "none" : "block",
                  length === 6
                    ? (i + 1) % 3
                      ? "block"
                      : "none"
                    : arr[i + 1]
                    ? "block"
                    : "none",
                ]}
              >
                <Icon
                  fontSize={"20px"}
                  top={"50%"}
                  right={"-15px"}
                  transform={"translateY(-50%)"}
                  position={"absolute"}
                  icon={ArrowRightStep}
                />
              </Box>
            </Box>
          ))}
      </Grid>
      {isFiveSteps && (
        <Box mt={3} position={"relative"} width={"100%"}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            position={"relative"}
            p={[0, "20px"]}
          >
            <Text
              mb={"12px"}
              color={
                content.steps[4]?.step_color?.color
                  ? content.steps[4].step_color.color
                  : "#8B7B8D"
              }
              fontWeight={500}
              letterSpacing={"0.1em"}
              fontSize={"12px"}
            >
              STEP {5}
            </Text>
            <Box position={"relative"}>
              <Image
                width={80}
                height={80}
                objectFit="cover"
                src={content.steps[4].icon.filename}
              />
            </Box>
            <Text
              mt={"12px"}
              fontSize={2}
              px={"20px"}
              color={"#000000CC"}
              lineHeight={"22.4px"}
              textAlign={"center"}
            >
              {content.steps[4].description}
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  );
};
